import { Pipe, PipeTransform } from '@angular/core';
import { AnyObj } from 'src/app/interfaces';

@Pipe({
  name: 'keyvalue',
})
export class KeyvaluePipe implements PipeTransform {
  transform(value: AnyObj): any[] {
    let keys = [];
    for (let key in value) {
      keys.push(key);
    }
    return keys.sort();
  }
}
